// SPDX-License-Identifier: LicenseRef-Proprietary
import React from 'react';

// Environment detection
const isDev =
  process.env.REACT_APP_ENVIRONMENT?.toLowerCase() === 'dev' ||
  process.env.NODE_ENV === 'development';

// prefer server-side login in prod; allow client/dev override if you have one
const LOGIN_PATH =
  process.env.REACT_APP_LOGIN_PATH ||
  (isDev ? '/auth/login' : '/api/auth/login'); // '/api/login' also works

interface LoginButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export const LoginButton: React.FC<LoginButtonProps> = ({ 
  className = '', 
  children = 'Sign In' 
}) => {
  const handleLogin = () => {
    window.location.assign(LOGIN_PATH);
  };

  return (
    <button
      onClick={handleLogin}
      className={`login-button ${className}`}
      type="button"
      aria-label="Sign in to EasyHTA"
    >
      {children}
    </button>
  );
};
